import { useState } from "react"
import { Link, router } from "@inertiajs/react"

export default function NotificationsDropdown({ organization, onClose }) {
  const [ markingAllRead, setMarkingAllRead ] = useState(false)
  const notificationsPath = `/${organization.id}/sync_alert_notifications`
  const markAllReadPath = `/${organization.id}/sync_alert_notifications/mark_all_read`

  function handleMarkAllRead(e) {
    e.preventDefault()
    if (markingAllRead) return
    setMarkingAllRead(true)
    router.patch(markAllReadPath, {}, {
      onFinish: () => {
        setMarkingAllRead(false)
        onClose()
      }
    })
  }

  return (
    <div className="absolute right-0 mt-2 w-80 bg-white dark:bg-zinc-900 rounded-lg shadow-lg border border-gray-200 dark:border-zinc-800 z-50">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 dark:border-zinc-800">
        <span className="text-sm font-semibold text-gray-900 dark:text-gray-100">Sync Failures</span>
        <button
          onClick={handleMarkAllRead}
          disabled={markingAllRead}
          className="text-xs text-blue-600 dark:text-blue-400 hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {markingAllRead ? "Marking..." : "Mark all read"}
        </button>
      </div>
      <div className="py-1">
        <Link
          href={notificationsPath}
          onClick={onClose}
          className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-zinc-800"
        >
          View all notifications →
        </Link>
      </div>
    </div>
  )
}
